import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Verifica o token salvo ao carregar o app
  useEffect(() => {
    const verifyAuth = async () => {
      const token = localStorage.getItem('access_token');

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Configura o token no header antes da requisição
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        const response = await api.get('/auth/me/');
        setUser(response.data);
      } catch (error) {
        // Token inválido ou expirado
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        delete api.defaults.headers.common.Authorization;
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    verifyAuth();
  }, []);

  // Login: recebe usuário, senha e token reCAPTCHA (quando habilitado),
  // retorna { success, user } ou { success: false, error }
  const login = async (username, password, captchaToken = null) => {
    try {
      const payload = { username, password };
      if (captchaToken) {
        payload.g_recaptcha_response = captchaToken;
      }
      const response = await api.post('/auth/token/', payload);
      const { access, refresh } = response.data;

      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);
      api.defaults.headers.common.Authorization = `Bearer ${access}`;

      // Busca os dados do usuário após o login
      const userResponse = await api.get('/auth/me/');
      setUser(userResponse.data);

      return { success: true, user: userResponse.data };
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        'Credenciais inválidas. Verifique usuário e senha.';
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    delete api.defaults.headers.common.Authorization;
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        // Helpers de papel usados por Layout, PrivateRoute, Dashboard e telas de lançamento
        isAdminMaster: user?.role === 'admin_master',
        isGestor: user?.role === 'gestor',
        isConsultor: user?.role === 'consultor',
        isStaff: user?.role === 'admin_master' || user?.role === 'gestor',
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
